import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { AppCenterAnalytics } from 'src/app/services/app-insights/app-insights';
import { AppInsightsService } from 'src/app/services/app-insights/app-insights.service';
import { ConfirmationAlertPopupComponent } from 'src/app/shared/confirmation-alert-popup/confirmation-alert-popup.component';

@Component({
  selector: 'app-request-historical-data-popup',
  templateUrl: './request-historical-data-popup.component.html',
  styleUrls: ['./request-historical-data-popup.component.scss'],
})
export class RequestHistoricalDataPopupComponent implements OnInit {
  selectYear!: string;
  historicalForm!: FormGroup;
  constructor(
    private readonly fb: FormBuilder,
    public dialogRef: MatDialogRef<ConfirmationAlertPopupComponent>,
    public readonly multilingualService: MultilingualService,
    private readonly appInsightsService: AppInsightsService,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    this.historicalForm = this.fb.group({
      year: ['', [Validators.required]],
      reason: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(
      AppCenterAnalytics.REQUEST_HISTORIC_DATA_FORM_VIEWED
    );
  }

  public request(): void {
    this.appInsightsService.trackPageView(
      AppCenterAnalytics.REQUEST_HISTORIC_DATA_FORM_SUBMIT_BUTTON_CLICKED
    );
    if (this.historicalForm.valid) {
      this.dialogRef.close(this.historicalForm.value);
    }
  }

  public cancel(): void {
    this.appInsightsService.trackPageView(
      AppCenterAnalytics.REQUEST_HISTORIC_DATA_FORM_CANCEL_BUTTON_CLICKED
    );
    this.dialogRef.close();
  }
}
